var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopoverRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 8,
    viewBox: "0 0 29 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 8L0 8L1.24959 8C3.92154 8 6.47432 6.96518 8.30178 5.14126L12.7369 0.714684C13.6917 -0.238229 15.3083 -0.23823 16.263 0.714682L20.6982 5.14126C22.5257 6.96518 25.0785 8 27.7504 8L29 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopoverRectangle);
export default __webpack_public_path__ + "static/media/4bd96339572ac5593d1e66d1a020185b8232cb5ca7.svg";
export { ForwardRef as ReactComponent };